import { shareColumnsExtend, shareFormColumnsExtend } from './share';

const entityColumns = {
  id: {
    model_name: 'Variant',
    column_type: 'id',
    label_key_path: 'variant.id',
  },
  created_at: {
    model_name: 'Variant',
    column_type: 'datetime',
    label_key_path: 'variant.createdAt',
  },
  updated_at: {
    model_name: 'Variant',
    column_type: 'datetime',
    label_key_path: 'variant.updatedAt',
  },
  product: {
    model_name: 'Variant',
    column_type: 'belongs_to',
    label_key_path: 'variant.product',
    extra: {
      association_name: 'product',
      model_name: 'Product',
      foreign_key: 'product_id',
      display_column: 'name',
    },
  },
  product_id: {
    model_name: 'Variant',
    column_type: 'belongs_to',
    label_key_path: 'variant.product',
    extra: {
      association_name: 'product',
      model_name: 'Product',
      foreign_key: 'product_id',
      display_column: 'name',
    },
  },
  sku: {
    model_name: 'Variant',
    column_type: 'string',
    label_key_path: 'variant.sku',
  },
  color_option_value: {
    model_name: 'Variant',
    column_type: 'belongs_to',
    label_key_path: 'variant.colorOptionValue',
    extra: {
      association_name: 'color_option_value',
      model_name: 'OptionValue',
      foreign_key: 'color_option_value_id',
      display_column: 'name',
    },
  },
  color_option_value_id: {
    model_name: 'Variant',
    column_type: 'belongs_to',
    label_key_path: 'variant.colorOptionValue',
    extra: {
      association_name: 'color_option_value',
      model_name: 'OptionValue',
      foreign_key: 'color_option_value_id',
      display_column: 'name',
    },
  },
  size_option_value: {
    model_name: 'Variant',
    column_type: 'belongs_to',
    label_key_path: 'variant.sizeOptionValue',
    extra: {
      association_name: 'size_option_value',
      model_name: 'OptionValue',
      foreign_key: 'size_option_value_id',
      display_column: 'name',
    },
  },
  size_option_value_id: {
    model_name: 'Variant',
    column_type: 'belongs_to',
    label_key_path: 'variant.sizeOptionValue',
    extra: {
      association_name: 'size_option_value',
      model_name: 'OptionValue',
      foreign_key: 'size_option_value_id',
      display_column: 'name',
    },
  },
  min_order_qty: {
    model_name: 'Variant',
    column_type: 'integer',
    label_key_path: 'variant.minOrderQty',
  },
  manufacture_flows: {
    model_name: 'Variant',
    column_type: 'has_many',
    label_key_path: 'variant.manufactureFlows',
    extra: {
      association_name: 'manufacture_flows',
      model_name: 'ManufactureFlow',
      foreign_key: 'variant_id',
      display_column: 'id',
    },
  },
  manufacture_flow_ids: {
    model_name: 'Variant',
    column_type: 'has_many',
    label_key_path: 'variant.manufactureFlows',
    extra: {
      association_name: 'manufacture_flows',
      model_name: 'ManufactureFlow',
      foreign_key: 'variant_id',
      display_column: 'id',
    },
  },
  variant_company_relations: {
    model_name: 'Variant',
    column_type: 'has_many',
    label_key_path: 'variant.variantCompanyRelations',
    extra: {
      association_name: 'variant_company_relations',
      model_name: 'VariantCompanyRelation',
      foreign_key: 'variant_id',
      display_column: 'id',
    },
  },
  variant_company_relation_ids: {
    model_name: 'Variant',
    column_type: 'has_many',
    label_key_path: 'variant.variantCompanyRelations',
    extra: {
      association_name: 'variant_company_relations',
      model_name: 'VariantCompanyRelation',
      foreign_key: 'variant_id',
      display_column: 'id',
    },
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
